module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/sitebuilder/hero-cycle/siteblocks-hero-1-hires.png";